// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

type IconListProps = {
  size?: number;
  fill?: string;
};

const IconList: React.FC<IconListProps> = ({ size = 24, fill = '#6F6F6F' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="7" r="1.5" fill={fill} />
    <rect x="9" y="6" width="12" height="2" rx="1" fill={fill} />

    <circle cx="5" cy="12" r="1.5" fill={fill} />
    <rect x="9" y="11" width="12" height="2" rx="1" fill={fill} />
    <circle cx="5" cy="17" r="1.5" fill={fill} />
    <rect x="9" y="16" width="12" height="2" rx="1" fill={fill} />
  </svg>
);

export default IconList;
